import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
};

const storeAssignmentsSlice = createSlice({
  name: 'storeAssignmentsUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, resetFilters } = storeAssignmentsSlice.actions;
const storeAssignmentsReducer = storeAssignmentsSlice.reducer;
export default storeAssignmentsReducer;
